import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../components/content/content.component';
import { AlertComponent } from '../../../common/alert/alert.component';
import { LabelComponent } from '../../../common/label/label.component';
import { UploaderAttachmentsService } from '../../../services/uploader-attachments.service';
import {
  AttachmentAppEntityIssueReportRead, IssueReportAppEntityIssueReportItemRead
} from '../../../openapi';

@Component({
  selector: 'app-e-application-preview-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    AlertComponent,
    LabelComponent
  ],
  providers: [UploaderAttachmentsService],
  templateUrl: './e-application-preview-page.component.html'
})
export class EApplicationPreviewPageComponent implements OnInit {

  // @ts-ignore
  public report: IssueReportAppEntityIssueReportItemRead | undefined = this.router.getCurrentNavigation()?.extras?.state['report']

  public photo1: AttachmentAppEntityIssueReportRead | null = this.report?.attachments
    ?.map(v => v.attachment)
    .filter(v => v?.tag === 'photo1')[0] || null;

  public photo2: AttachmentAppEntityIssueReportRead | null = this.report?.attachments
    ?.map(v => v.attachment)
    .filter(v => v?.tag === 'photo2')[0] || null;

  public photo3: AttachmentAppEntityIssueReportRead | null = this.report?.attachments
    ?.map(v => v.attachment)
    .filter(v => v?.tag === 'photo3')[0] || null;

  public mapImage: AttachmentAppEntityIssueReportRead | null = this.report?.attachments
    ?.map(v => v.attachment)
    .filter(v => v?.tag === 'map_image')[0] || null;

  public get showAttachments(): boolean {
    return !!this.photo1 || !!this.photo2 || !!this.photo3;
  }

  public pending = false;

  constructor(
    private uploaderService: UploaderAttachmentsService,
    private router: Router
  ) {
  }

  public onDownloadAttachment(event: Event, v: AttachmentAppEntityIssueReportRead | null): void {
    event.preventDefault();
    event.stopPropagation();
    this.uploaderService.downloadAttachment(v?.id || '', v?.originalName).subscribe();
  }

  public ngOnInit(): void {
  }

}
